import React from 'react'
import { Card, CardActions, CardContent, Divider } from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton'
import SaveIcon from '@mui/icons-material/Save'

interface ICardWithActionButtonProps {
  buttonText?: string
  loading: boolean
  handleClick?: () => void
  children: React.ReactNode
  showIcon?: boolean
  cardContentPadding?: string
  buttonSize?: 'small' | 'medium' | 'large'
  otherActionComponents?: React.ReactNode
}

/**
 * CardWithActionButton Page
 *
 * @param __namedParameters ICardWithActionButtonProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const CardWithActionButton: React.FC<ICardWithActionButtonProps> = ({
  buttonText = 'SAVE',
  loading = false,
  handleClick,
  children,
  showIcon = true,
  cardContentPadding = '26px',
  buttonSize = 'medium',
  otherActionComponents,
}): JSX.Element => {
  return (
    <Card sx={{ width: '100%' }}>
      <CardContent sx={{ padding: cardContentPadding }}>{children}</CardContent>
      <Divider />
      <CardActions sx={{ justifyContent: 'flex-end', padding: '16px' }}>
        {otherActionComponents}
        <LoadingButton
          color="primary"
          onClick={handleClick}
          type="submit"
          loading={loading}
          loadingPosition="start"
          startIcon={showIcon && <SaveIcon />}
          variant="contained"
          size={buttonSize}
          sx={{ fontSize: '15px', width: '101px', height: '42px' }}
        >
          {buttonText}
        </LoadingButton>
      </CardActions>
    </Card>
  )
}
